import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import type { CheckoutResponseData } from '../../../shared/api/cart.js'

interface Props {
  order: CheckoutResponseData
  currency: string
  orgSlug: string
  onBackToMenu: () => void
}

export default function OrderSuccess({ order, currency, orgSlug, onBackToMenu }: Props) {
  const { t } = useTranslation()

  return (
    <div className="storefront-order-success">
      <div className="storefront-order-success-icon">🎉</div>
      <h2>{t('orderSuccess.title')}</h2>

      <div className="storefront-order-success-card">
        <div className="storefront-order-success-row">
          <span>{t('orderSuccess.number')}</span>
          <strong>{order.orderNumber}</strong>
        </div>
        <div className="storefront-order-success-row">
          <span>{t('orderSuccess.status')}</span>
          <strong>{t('orderSuccess.pendingConfirmation')}</strong>
        </div>
        <div className="storefront-order-success-row">
          <span>{t('orderSuccess.total')}</span>
          <strong>{order.total} {currency}</strong>
        </div>
      </div>

      <p className="storefront-order-success-info">{t('orderSuccess.info')}</p>

      <Link
        className="btn btn-ghost storefront-order-tracking-link"
        to={`/s/${orgSlug}/order/${order.publicToken}`}
      >
        {t('orderSuccess.trackOrder')}
      </Link>

      <button type="button" className="btn btn-primary" onClick={onBackToMenu}>
        {t('orderSuccess.backToMenu')}
      </button>
    </div>
  )
}